module.exports = __webpack_public_path__ + "static/media/ic-season-autumn.cd45ee9a.svg";